import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { DispatchProps, OwnProps, StateProps } from './VendorInfoScreen';
import VendorInfo from './VendorInfoScreen';
import { StoreState } from 'src/store/reducers';
import { getVendor, getFiles } from 'src/store/actions/vendor-actions';

function mapStateToProps(state: StoreState): StateProps {
    return {
        vendor: state.vendors.current,
        files: state.vendors.currentFiles,
    };
}

function mapDispatchToProps(dispatch: Dispatch): DispatchProps {
    return {
        getData: (id) => dispatch(getVendor(id)),
        getFiles: (id) => dispatch(getFiles(id)),
    };
}

const VendorInfoScreen = connect<StateProps, DispatchProps, OwnProps, StoreState>(
    mapStateToProps,
    mapDispatchToProps,
)(VendorInfo);

export default VendorInfoScreen;
